import { executeRequest, Request } from '@jfs/network'
import { vaultColumnParser } from './../network/parsers/vaultColumnParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = vaultColumnParser(data)
  return respData
}

const getTokenTxnHistoryColumn = (tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.TransactionColumnV3,
    method: 'GET',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getTokenTxnHistoryColumn }
